import { render, staticRenderFns } from "./TeamWindows.vue?vue&type=template&id=18057fcc&scoped=true&"
import script from "./TeamWindows.vue?vue&type=script&lang=js&"
export * from "./TeamWindows.vue?vue&type=script&lang=js&"
import style0 from "./TeamWindows.vue?vue&type=style&index=0&id=18057fcc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18057fcc",
  null
  
)

export default component.exports